import { GetTravelVoucherModel } from "@factory/model/query-model-travel-voucher";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { travelVoucherFormDefault } from "./form.default";
import { TravelVoucherFormSchema } from "./form.rule";

export const useFormDefaultTravelVoucher = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTravelVoucherModel | undefined) => {
    return !cachedValue
      ? travelVoucherFormDefault
     : ({
        baseInvoice: cachedValue.base_invoice,
        confirmationNum: cachedValue.confirmation_num,
        paymentCompletion: cachedValue.payment_completion,
        isFullyPaid: Boolean(cachedValue.is_fully_paid),
        amountPaid: cachedValue.amount_paid,
        amount: cachedValue.amount,
      } as TravelVoucherFormSchema);
  };

  return {
    getDefault,
  };
};
